import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { ADD_PRODUCT_CATEGORY_PATH } from '@app/constants';
import { useNewUserAccessRights } from '@app/hooks';

export const useProductCategoriesHeader = () => {
  const navigate = useNavigate();
  const {
    userAccessRights: {
      Products: { IsProductCategoryCreate },
    },
  } = useNewUserAccessRights();
  const goToAddCategory = useCallback(
    () => navigate(ADD_PRODUCT_CATEGORY_PATH),
    [navigate]
  );

  return { goToAddCategory, IsProductCategoryCreate };
};
